var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a720bbb0-38a4-4918-9cbb-78f50a428a6e",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ea5e2d7d-0ada-4b67-96fe-a706f466eb0d{opacity:0.4;}.e3fdc791-08df-4cf3-a07d-faa7809711fe{fill:#110e1a;}\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-caption-text") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ea5e2d7d-0ada-4b67-96fe-a706f466eb0d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e3fdc791-08df-4cf3-a07d-faa7809711fe",
    d: "M12.33333,9.33333h8.33334a.66667.66667,0,0,0,0-1.33333H12.33333a.66667.66667,0,0,0,0,1.33333Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e3fdc791-08df-4cf3-a07d-faa7809711fe",
    d: "M7.33333,9.33333H9.66667A.66667.66667,0,0,0,9.66667,8H7.33333a.66667.66667,0,0,0,0,1.33333Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e3fdc791-08df-4cf3-a07d-faa7809711fe",
    d: "M20.66667,11.55555H16.33333a.66667.66667,0,0,0,0,1.33334h4.33334a.66667.66667,0,0,0,0-1.33334Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e3fdc791-08df-4cf3-a07d-faa7809711fe",
    d: "M7.33333,12.88889h6.33334a.66667.66667,0,0,0,0-1.33334H7.33333a.66667.66667,0,0,0,0,1.33334Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e3fdc791-08df-4cf3-a07d-faa7809711fe",
    d: "M20.66667,15.11111H7.33333a.66667.66667,0,0,0,0,1.33333H20.66667a.66667.66667,0,0,0,0-1.33333Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e3fdc791-08df-4cf3-a07d-faa7809711fe",
    d: "M13.22222,18.66667H7.33333a.66667.66667,0,0,0,0,1.33333h5.88889a.66667.66667,0,1,0,0-1.33333Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.0747935ed71979d2088703461ba6d830.svg";
export { ForwardRef as ReactComponent };